<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
            :newPrice="newPrice"
            :uom="uom"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <div class="h-100 d-flex justify-content-center align-items-center" v-if="isLoading">
                <vue-loaders-ball-beat scale="2" color="black" />
            </div>
            <div v-else>
                <price-deviation-prod-info
                    :submission="submission"
                    :styleAndSkus="styleAndSkus"
                    :imgSource="imgSource"
                    :custInfo="custInfo"
                ></price-deviation-prod-info>
                <br>
                <div>
                    <form @submit.prevent method="POST" @keydown.enter.prevent>
                        <h2>New Pricing Information</h2>
                        <em id="em-stylings">
                            Fill-out the required information below, which will be applied to the SKUs selected above.
                        </em>
                        <br />
                        <em id="em-stylings" style="color:#cd1b00;">
                            New LIST pricing will be provided 60 days in advance of a new semi-annual price list and will be used <br />
                            in variance calculations when submitting deviation requests in the window leading up to the semi-annual price list going live.
                        </em>
                        <br /><br />
                        <div>
                            <ul id="horizontal-ul">
                                <li class="col-md-2" style="padding-left:0;">
                                    <span style="color:#cd1b00;">*</span> Requested By:
                                    <admin-select v-model="requestedBy" required>
                                        <option></option>
                                        <option v-for="(userId, name) in priceAuthUsers" :value="userId">{{ name }}</option>
                                    </admin-select>
                                </li>
                                <li class="col-md-2">
                                    <span style="color:#cd1b00;">*</span> Suggested Price:
                                    <input v-model="suggestedPrice" @change="calculate($event);" type="number" step="0.01" style="width:100%;" required />
                                    <p>
                                        <span id="newPrice" style="display:none;color:#cd1b00;font-size:0.8rem;"></span>
                                        <span id="suggPriceValues">CURR CUST: <strong>${{ currPrice }}</strong> | NEW CUST: <strong>${{ newPrice }}</strong></span><br>
                                        <span id="suggPriceValues">NEW LIST: <strong>${{ listPrice }}</strong></span><br>
                                        <span id="suggPriceValues">VAR% OFF NEW LIST: <span></span><strong>{{ suggestedVar }}%</strong></span>
                                    </p>
                                </li>
                                <li class="col-md-2" v-if="activityId == '1' || activityId == '4'">
                                    <span style="color:#cd1b00;">*</span> Effective Date:
                                    <input v-model="effectiveDate" type="date" style="width:100%;" required />
                                </li>
                                <li class="col-md-2" v-if="activityId == '1' || activityId == '4'">
                                    <span style="color:#cd1b00;">*</span> Expiration Date:
                                    <input v-model="expirationDate" type="date" style="width:100%;" required />
                                </li>
                                <li class="col-md-2">
                                    <span style="color:#cd1b00;">*</span> Projected Annual Sales:
                                    <admin-select v-model="projSales" required>
                                        <option></option>
                                        <option>$1 - $2,499</option>
                                        <option>$2,500 - $4,999</option>
                                        <option>$5,000 - $9,999</option>
                                        <option>$10,000 - $14,999</option>
                                        <option>$15,000+</option>
                                    </admin-select>
                                </li>
                                <li class="col-md-2">
                                    <span style="color:#cd1b00;">*</span> Business Rationale:
                                    <admin-select v-model="businessRationale" required>
                                        <option></option>
                                        <option v-for="rationale in businessRationaleOptions" :value="rationale">{{ rationale }}</option>
                                    </admin-select>
                                </li>
                            </ul>
                        </div>
                        <br />
                        <div style="display: flex; align-items: flex-start;">
                            <div class="col-md-4" style="min-height:auto; padding-left:0; padding-right:0;">
                                <h4>Product Substitution</h4>
                                <ul id="horizontal-ul">
                                    <li class="col-md-6" style="padding-left:0;">
                                        What item are we substituting from?
                                        <input v-model="itemSubstitution" type="text" style="width:100%;" />
                                    </li>
                                    <li class="col-md-6">
                                        Was the item backordered?<br />
                                        <input v-model="isBackordered" type="radio" name="rationale_sub_backorder" value="Y">Yes
                                        <input v-model="isBackordered" type="radio" name="rationale_sub_backorder" value="N" style="margin-left:10px;">No
                                    </li>
                                </ul>
                            </div>
                            <div v-if="businessRationale == 'Internal Product Conversion'" class="col-md-4" style="min-height:auto; padding-left:0; padding-right:0;">
                                <h4>Internal Product Conversion</h4>
                                <ul id="horizontal-ul">
                                    <li class="col-md-6" style="padding-left:0;">
                                        <span style="color:#cd1b00;">*</span> What style is this new deviation replacing?
                                        <input v-model="prodConvStyle" type="text" style="width:100%;" :required="isProdConvRequired" />
                                    </li>
                                    <li class="col-md-6">
                                        <span style="color:#cd1b00;">*</span> Date to expire old deviation(s)?
                                        <input v-model="prodConvExpiration" type="date" style="width:100%;" :required="isProdConvRequired" />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <br />
                        <div>
                            <h4>Competitive SKU Information</h4>
                            <ul id="horizontal-ul">
                                <li class="col-md-2" style="padding-left:0;">
                                    Manufacturer:
                                    <input v-model="compManufacturer" type="text" style="width:100%;" />
                                </li>
                                <li class="col-md-2">
                                    SKU:
                                    <input v-model="compSku" type="text" style="width:100%;" />
                                </li>
                                <li class="col-md-2">
                                    UOM:
                                    <admin-select v-model="compUom">
                                        <option></option>
                                        <option value="bg">bag (bg)</option>
                                        <option value="bx">box (bx)</option>
                                        <option value="cs">case (cs)</option>
                                        <option value="dz">dozen (dz)</option>
                                        <option value="ea">each (ea)</option>
                                        <option value="ip">innerpack (ip)</option>
                                        <option value="pk">pack (pk)</option>
                                        <option value="pr">pair (pr)</option>
                                    </admin-select>
                                </li>
                                <li class="col-md-2">
                                    Price:
                                    <input v-model="compPrice" type="number" step="0.01" style="width:100%;" />
                                </li>
                            </ul>
                        </div>
                        <br />
                        <div>
                            <h4>Urgency</h4>
                            <input v-model="urgency" type="checkbox" value="1" />  Is this an Urgent request? If yes, check the box and provide the order number(s) below:<br />
                            <ul class="col-md-10" style="list-style-type:none; display:flex; flex-wrap:wrap; padding-left:0;">
                                <li class="col-md-3" v-for="i in 8" :key="i" style="padding-left:0;">
                                    <input
                                        type="text"
                                        :name="'ord_num['+(i-1)+']'"
                                        class="input"
                                        id="orderNumInputs"
                                        v-model="ordNum[i-1]"
                                        :placeholder="'Order #' + i"
                                        :required="isOneTime && i === 1"
                                        :pattern="'^S.*'"
                                        title="First character must be an 'S'"
                                        :minlength="8"
                                        :maxlength="8"
                                    />
                                </li>
                            </ul>
                            <br />
                            Any additional details?<br />
                            <textarea v-model="additionalDetails" style="width:60%;" rows="5"></textarea>
                        </div>
                        <br />
                        <br />
                        <div>
                            <button 
                                v-if="canSubmitAnother && !isEditing" 
                                class="btn-round-green" 
                                value="submit_another"
                                @click="savePricing('submitAnother')"
                            >
                                SUBMIT ANOTHER
                            </button>
                            <button 
                                class="btn-round-red" 
                                value="finish"
                                @click="savePricing('finished')"
                            >
                                FINISH >
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activity: "",
            activityId: "",
            additionalDetails: null,
            businessRationale: null,
            businessRationaleOptions: null,
            businessRationaleOptionsOneTime: [
                '1X Honoring of Old Pricing', 
                'Bulk Buy of Stock Items', 
                'DEAD/DISC Special Pricing', 
                'New Business Discount', 
                'Promo/Show Pricing', 
                'Regain Lost Business',
                'Tariff Concession'
            ],
            businessRationaleOptionsStandard: [
                'DEAD/DISC Special Pricing', 
                'Internal Product Conversion', 
                'New Business', 
                'New Everyday Pricing', 
                'Promo/Show Pricing', 
                'Regain Lost Business', 
                'Retain/Extend Existing Pricing',
                'Tariff Concession'
            ],
            canSubmitAnother: false,
            compManufacturer: null,
            compPrice: null,
            compSku: null,
            compUom: null,
            currPrice: null,
            custInfo: {},
            effectiveDate: null,
            expirationDate: null,
            i:8,
            imgSource: null,
            isBackordered: null,
            isLoading: true,
            isOneTime: false,
            itemSubstitution: null,
            listPrice: null,
            newPrice: null,
            ordNum: ["","","","","","","",""],
            price: "",
            priceAuthUsers: [],
            prodConvExpiration: null,
            prodConvStyle: null,
            projSales: null,
            requestedBy: null,
            styleAndSkus: {},
            submission: {},
            suggestedPrice: null,
            uom: null,
            urgency: null,
        }
    },
    props: ['ppId'],
    created() {
        axios.get(`/api/getPriceAuthUsers`).then(response => {
            this.priceAuthUsers = response.data;
        });

        axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
            this.submission = response.data;

            this.requestedBy = this.submission.requested_by;
            this.suggestedPrice = this.submission.sug_price;
            this.effectiveDate = this.submission.eff_date;
            this.expirationDate = this.submission.expiration_date;
            this.projSales = this.submission.proj_sales;
            this.businessRationale = this.submission.rationale;
            this.itemSubstitution = this.submission.rationale_sub_style;
            this.isBackordered = this.submission.rationale_sub_backorder;
            this.compManufacturer = this.submission.rationale_comp_mfg;
            this.compSku = this.submission.rationale_comp_sku;
            this.compUom = this.submission.rationale_comp_uom;
            this.compPrice = this.submission.rationale_comp_price;
            this.urgency = this.submission.urgent;
            this.additionalDetails = this.submission.add_details;
            this.activityId = this.submission.activity.id;
            this.activity = this.submission.activity.activity;
            this.prodConvExpiration = this.submission.prod_conv_exp;
            this.prodConvStyle = this.submission.prod_conv_style;

            if(this.submission.ord_num != null) {
                let ordNums = this.submission.ord_num.split("|");
                this.ordNum = ordNums;
            }

            if(this.activityId == 2) {
                this.isOneTime = true;
            } else {
                this.isOneTime = false;
            }

            axios.get(`/api/customerInfo/${this.submission.cust_id}`).then(response => {
                this.custInfo = response.data;
            });

            axios.get(`/api/getStyleAndChildrenSkus/${this.submission.id}`).then(response => {
                this.styleAndSkus = response.data;
                this.imgSource = this.styleAndSkus['img_source'];
                this.currPrice = this.styleAndSkus['curr_price'];
                this.newPrice = this.styleAndSkus['new_price'];
                this.listPrice = this.styleAndSkus['list_price'];
                this.uom = this.styleAndSkus['uom'];

                this.isLoading = false;
            });

            if(this.activityId == 2) {
                this.businessRationaleOptions = this.businessRationaleOptionsOneTime;
            } else {
                this.businessRationaleOptions = this.businessRationaleOptionsStandard;
            }

            if(this.submission.id != this.submission.parent_id) {
                this.canSubmitAnother = true;
            }
        })
    },
    computed: {
        suggestedVar() {
            if(this.listPrice != null && this.suggestedPrice != null) {
                return (((this.listPrice - this.suggestedPrice) / this.listPrice) * -100).toFixed(2);
            }
        },
        isProdConvRequired() {
            return this.businessRationale == 'Internal Product Conversion';
        },
        isEditing() {
            return this.$route.query.editing === 'true';
        }
    },
    methods: {
        async savePricing(intention) {
            let payload = {
                additionalDetails: this.additionalDetails,
                businessRationale: this.businessRationale,
                compManufacturer: this.compManufacturer,
                compPrice: this.compPrice,
                compSku: this.compSku,
                compUom: this.compUom,
                effectiveDate: this.effectiveDate,
                expirationDate: this.expirationDate,
                id: this.submission.id,
                isBackordered: this.isBackordered,
                itemSubstitution: this.itemSubstitution,
                ordNum: this.ordNum,
                prodConvExpiration: this.prodConvExpiration,
                prodConvStyle: this.prodConvStyle,
                projSales: this.projSales,
                requestedBy: this.requestedBy,
                suggestedPrice: this.suggestedPrice,
                suggestedVar: this.suggestedVar,
                urgency: this.urgency,
                intention: intention
            }

            const { data } = await axios.post(`/api/savePricingInformation`, payload);

            // get id from new submission in response
            if(intention == 'submitAnother' && data) {
                this.$router.push({
                    name: "PriceWorkflowStyleSelect",
                    params: { ppId: data }
                });
            } else {
                this.$router.push({
                    name: "PriceWorkflowDashboards",
                    params: {dashboard: "PriceDeviation"}
                });
            }
        },
        calculate(event) {
            if(this.uom == "DZ") {
                let input = (Math.round(event.target.value * 100)/100).toFixed(2);
                let newPrice = ((input / 12).toFixed(2) * 12).toFixed(2);

                if(input != newPrice) {
                    $('#newPrice').show().html('PLEASE ADJUST PRICE TO $' + newPrice + '<br>');
                } else {
                    $('#newPrice').hide();
                }
                if(event.keyCode == 8) {
                    $('#newPrice').hide();
                }
            }
        }
    },
}
</script>

<style scoped>
    #horizontal-ul {
        list-style-type:none;
        display: flex;
    }

    #em-stylings {
        font-size:.9rem; 
        font-weight:normal; 
        line-height:1.0
    }
    
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    h4 {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    #orderNumInputs {
        width: 100%;
        margin-bottom:1rem;
    }

    #suggPriceValues {
        color:#666;
        font-size:0.8rem;
    }
</style>
